import { render, staticRenderFns } from "./HipsterSizeChart.vue?vue&type=template&id=6642b435&"
import script from "./HipsterSizeChart.vue?vue&type=script&lang=js&"
export * from "./HipsterSizeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports